import { useMemo } from 'react';

import { useNextFixtureProbablePitchersSlugs } from '#src/hooks/config/useNextFixtureProbablePitchersSlugs.tsx';
import { joinFiltersWithOr } from '#src/lib/algolia.ts';

type Props = {
  probablePitchersFilterValue: string | undefined;
  skip: boolean;
};

export const useProbablePitchersFilterValue = ({
  probablePitchersFilterValue,
  skip,
}: Props) => {
  const { probablePitchersForNextGameWeeks = [] } =
    useNextFixtureProbablePitchersSlugs(skip);

  const playingNextGameweekFilterValues = useMemo(
    () =>
      probablePitchersForNextGameWeeks.reduce<Record<string, string>>(
        (acc, { gameWeek, playerSlugs }) => ({
          ...acc,
          [gameWeek.toString()]: joinFiltersWithOr(
            playerSlugs.map(slug => `player.slug:${slug}`)
          ),
        }),
        {}
      ),
    [probablePitchersForNextGameWeeks]
  );
  if (!probablePitchersFilterValue) return null;

  return playingNextGameweekFilterValues[probablePitchersFilterValue];
};
